import { render, staticRenderFns } from "./rosterGradeTable.vue?vue&type=template&id=b7fe50fe&scoped=true"
import script from "./rosterGradeTable.vue?vue&type=script&lang=js"
export * from "./rosterGradeTable.vue?vue&type=script&lang=js"
import style0 from "./rosterGradeTable.vue?vue&type=style&index=0&id=b7fe50fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fe50fe",
  null
  
)

export default component.exports